import { useEventListener } from './useEventListener';

/**
 * Hook that listens for tab focus events on the window
 * @param callback Function to call when tab focus is detected
 */
export const useOnTabFocus = (callback: (event: Event) => void): void => {
  useEventListener({ target: window, eventName: 'focus', callback });
};
